import {gsap} from '../../_Global/js/global';

document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.gtHeader');
    const headerWrapper = document.querySelector('.gtHeader>div');
    const menu = document.querySelector('.megaMenu');
    const menuButtons = document.querySelectorAll('.megaMenuOpen');
    const globalSearch = document.querySelector('.globalSearch');
    const searchButtons = document.querySelectorAll('.globalSearchOpen');
    const scrollDistanceThreshold = 200; // Pixels to scroll before showing/hiding header
    let scrollUpStatus = false;
    let scrollUpPosition = 0;
    let scrollLastPosition = 0;

    if (header) {
        searchButtons.forEach((button) => {
            button.addEventListener('click', () => {
                globalSearch.classList.add('active');
                gsap.fromTo(globalSearch, {opacity: 0}, {opacity: 1, duration: 0.3, ease: 'power2.out'});

                trapFocus(globalSearch);
                globalSearch.querySelector('.globalSearchClose').focus();
            });
        });

        menuButtons.forEach((button) => {
            button.addEventListener('click', () => {
                menu.classList.add('active');
                gsap.fromTo(menu, {opacity: 0}, {opacity: 1, duration: 0.3, ease: 'power2.out'});

                trapFocus(menu);
                menu.querySelector('.megaMenuClose').focus();
            });
        });

        checkScroll();
        window.addEventListener('scroll', checkScroll);
    }

    function trapFocus(element) {
        const focusableElements = element.querySelectorAll('a, button, input, textarea, select');
        const firstFocusableElement = focusableElements[0];
        const lastFocusableElement = focusableElements[focusableElements.length - 1];

        document.querySelector('html').classList.add('no-scroll');

        document.addEventListener(
            'keydown',
            function (e) {
                if (e.key === 'Tab') {
                    if (e.shiftKey) {
                        // Shift + Tab
                        if (document.activeElement === firstFocusableElement) {
                            e.preventDefault();
                            lastFocusableElement.focus();
                        }
                    } else {
                        // Tab
                        if (document.activeElement === lastFocusableElement) {
                            e.preventDefault();
                            firstFocusableElement.focus();
                        }
                    }
                }
            },
            true,
        );
    }

    function checkScroll() {
        const scrollCurrentPosition = window.scrollY || window.pageYOffset;

        if (scrollCurrentPosition >= 0 && scrollCurrentPosition <= headerWrapper.offsetHeight) {
            //At the top
            gsap.killTweensOf(headerWrapper);
            gsap.to(headerWrapper, {y: 0, duration: 0});
            header.classList.remove('detached');
            scrollUpStatus = false;
            scrollUpPosition = 0;

            return;
        }

        if (scrollCurrentPosition >= 0 && scrollCurrentPosition <= scrollLastPosition) {
            //Scrolling up
            if (!scrollUpStatus) {
                //Beginning to scroll up
                scrollUpStatus = true;
                scrollUpPosition = scrollCurrentPosition;
            } else {
                //Already scrolling
                if ((Math.abs(scrollUpPosition - scrollCurrentPosition) > scrollDistanceThreshold) & !header.classList.contains('detached')) {
                    //Show header
                    header.classList.add('detached');
                    gsap.killTweensOf(headerWrapper);
                    gsap.fromTo(headerWrapper, {y: -headerWrapper.offsetHeight - 15}, {y: 0, duration: 0.3, ease: 'power2.out'});
                    gsap.to(headerWrapper, {y: 0, duration: 0.5, ease: 'power2.out'});
                }
            }
        } else {
            //Scrolling down
            scrollUpStatus = false;
            scrollUpPosition = 0;

            if (header.classList.contains('detached')) {
                gsap.killTweensOf(headerWrapper);
                gsap.to(headerWrapper, {
                    y: -headerWrapper.offsetHeight - 15,
                    duration: 0.5,
                    ease: 'power2.out',
                    onComplete: () => {
                        header.classList.remove('detached');
                    },
                });
            }
        }

        scrollLastPosition = scrollCurrentPosition;
    }
});
